import React, { useState } from "react";
import { useAnalyticsApi } from "react-use-analytics-api";
import { BounceRateChart } from "react-analytics-charts";
import { Tooltip, Box } from "@mui/material/";
import { AuthorizeButton } from "react-analytics-charts";
import { AnalyticsDashboard } from "react-analytics-charts";
import { PageViewsPerPathChart } from "react-analytics-charts";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useTranslation } from "react-i18next";

const Bounce = ({ dashboard }) => {
  const [period, setPeriod] = useState(30);
  const { t, i18n } = useTranslation();

  const { ready, gapi, authorized, error } = useAnalyticsApi();
  let clientId =
    "568824200639-58enea0l8cr2arus6f1hech205ibqvci.apps.googleusercontent.com";
  let viewId = "261404142";
  const signInHandler = () => {};
  return (
    <Box>
      {!dashboard && (
        <Box sx={{ mt: 3 }}>
          <Box sx={{ pt: 3, pb: 1, fontSize: "22px" }}>
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              {t("Page Views Per Path(URL) Chart")}
            </span>
            <span className="pink_link"></span>
          </Box>
          <Box sx={{ pb: 1, color: "gray" }}>{t("pageviews")}</Box>
        </Box>
      )}

      <FormControl sx={{ mt: 2, width: 300 }}>
        <InputLabel id="demo-simple-select-label">{t("Set Period")}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={period}
          label="Period"
          onChange={(e) => setPeriod(e.target.value)}
          sx={{ width: 300 }}
        >
          <MenuItem value={10}>10 {t("Days")}</MenuItem>
          <MenuItem value={30}>1 {t("Month")}</MenuItem>
          <MenuItem value={60}>3 {t("Month")}</MenuItem>
          <MenuItem value={180}>6 {t("Month")}</MenuItem>
          <MenuItem value={270}>9 {t("Month")}</MenuItem>
          <MenuItem value={365}>1 {t("Year")}</MenuItem>
        </Select>
      </FormControl>
      <AnalyticsDashboard
        authOptions={{ clientId }}
        renderCharts={(gapi, viewId) => {
          return (
            <Box sx={{ fontSize: "11px" }}>
              <PageViewsPerPathChart
                gapi={gapi}
                viewId={viewId}
                days={period}
              />
            </Box>
          );
        }}
      />
    </Box>
  );
};

export default Bounce;
